import heroScripts from "./components/heroScripts";
import DenHaagHeroThemeImage from "./components/DenHaagHeroThemeImage";

window.addEventListener( "DOMContentLoaded", () => {
  heroScripts();
  DenHaagHeroThemeImage();
} );

window.addEventListener( "dh:resize", () => DenHaagHeroThemeImage() );
